import { ReactElement } from 'react';
import { Descriptions, Tag } from 'antd';
import type { CallDirection } from '@minutes-system/backend/src/api/recordings/callDirection';

const callDirectionConfig: Record<CallDirection, { label: string; color: string }> = {
  outgoing: { label: '架電', color: 'blue' },
  incoming: { label: '受電', color: 'purple' },
  unknown: { label: '判別不能', color: 'default' },
};

interface Props {
  title: string;
  advisor: string;
  customer: string;
  meetingDateTime: string;
  callDirection: CallDirection;
}

const RecordingInfoDisplay = ({ title, advisor, customer, meetingDateTime, callDirection }: Props): ReactElement => {
  return (
    <Descriptions column={2} size='small' layout='vertical'>
      <Descriptions.Item label='タイトル' span={2}>
        {title}
      </Descriptions.Item>
      <Descriptions.Item label='営業担当者' span={2}>
        {advisor}
      </Descriptions.Item>
      <Descriptions.Item label='顧客名' span={2}>
        {customer}
      </Descriptions.Item>
      <Descriptions.Item label='面談日時' span={2}>
        {meetingDateTime}
      </Descriptions.Item>
      <Descriptions.Item label='種別' span={2}>
        <Tag color={callDirectionConfig[callDirection].color} bordered={false}>
          {callDirectionConfig[callDirection].label}
        </Tag>
      </Descriptions.Item>
    </Descriptions>
  );
};

export default RecordingInfoDisplay;
